import state from './staffState'
import mutations from './staffMutations'
import getters from './staffGetters'
import actions from './staffActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
